import React from "react";

const AboutExistsSection = () => {
  return (
    <section className="section section-soft about-exists-section">
      <div className="container">
        <div className="split-grid reverse-on-mobile">
          <div>
            <p className="eyebrow">Why Lovapex Exists</p>
            <h2>
              The job search is complex. International professionals feel that
              complexity first.
            </h2>
            <p>
              Job boards, ATS filters, sponsor uncertainty, recruiter silence,
              resume tailoring, interview preparation, and negotiation all
              compete for attention at the same time. For international
              professionals, timing and visa clarity make every step even more
              important.
            </p>
            <p>
              Lovapex exists as an execution partner: a team that helps
              candidates focus on the right roles, present themselves clearly,
              follow up consistently, and keep the entire search moving with
              visibility.
            </p>
          </div>
          <div
            className="section-image about-exists-image"
            aria-label="Career strategy session with international professionals"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default AboutExistsSection;
